<template>
  <div class="feature">
    <div class="feature_icon">
      <div :style="getColorStyle" class="feature_icon_bg" />
      <img :src="img" alt="">
    </div>
    <div class="feature_title">
      <p v-html="title" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    img: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: null,
    },
  },
  computed: {
    getColorStyle () {
      return (this.color) ? { background: this.color } : null
    },
  },
}
</script>

<style lang="less">
.feature {
	display: flex;
	flex-direction: column;
	align-items: center;

	&_icon {
		--box: 150px;

		width: var(--box);
		height: var(--box);
		margin-bottom: 25px;
		position: relative;

		@media screen and (max-width: 768px) {
			--box: 130px;
		}

		&_bg {
			width: var(--box);
			height: var(--box);
			background-color: rgb(182, 182, 182);
			border-radius: 44px;
			z-index: 1;
			position: absolute;
			top: calc(50% - 12px);
			left: calc(50% + 12px);
			transform: rotate(-10deg) translate(-50%, -50%);
		}

		img {
			width: var(--box);
			height: var(--box);
			object-fit: contain;
			object-position: center;
			z-index: 2;
			position: absolute;
			top: 50%;
			left: 50%;
			transform: translate(-50%, -50%);
		}
	}

	&_title {
		max-width: 100%;
		width: 230px;

		p {
			font-family: 'Roboto', Arial, sans-serif;
			font-size: 18px;
			text-align: center;
			line-height: 1.3;
		}
	}

  @media screen and (max-width: 768px) {
    margin-top: 30px;
  }
}
</style>
